import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { WebAppFooter } from "./WebAppFooter";
import { WebAppFooterIcons } from "./WebAppFooterIcons";
export const WebAppFooterTabs = () => {
  const navigate = useNavigate();
  const query = useQuery();

  useEffect(() => {
    if(query.get('id')){
      return;
    }
    if (query.get('subActiveTab') === 'webAppFooterIcons' && !query.get('thirdChildActiveTab')) {
      navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=webAppFooterIcons&thirdChildActiveTab=servicePortals`, { replace: true });
    }
  }, [query.get('subActiveTab')]);

  const items = [
    {
      label: "About & Legal",
      key: "aboutAndLegal",
      children: <WebAppFooter />,
    },
    {
      label: "Icons",
      key: "webAppFooterIcons",
      children: <WebAppFooterIcons />,
    },
  ];

  return (
    <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${activeKey}`);
        }}
      ></Tabs>
  );
};
